import { createStore } from 'core/common/utils/store'
import { addManyItensArray, removeManyItensArray } from 'core/common/utils/string'
import { DEFAULT_HIDDEN_STEPS } from './constants'

export type TSetStoreAction<T> = (values: T) => void
export type TSetStoreActionSimple<T> = (prevState: T) => void

export type TSetInitStoreAction = () => void

export type TStepsConfigStore = {
  activeSubStep: number
  hiddenSteps: string[]
  activeStepIndex: number
  finalizedSteps: string[]
  editingStep: null | string
  setFinishedSteps: TSetStoreAction<string[]>
  setHiddenStep: TSetStoreAction<string[]>
  setActiveStepIndex: TSetStoreAction<number>
  setVisibleStep: TSetStoreAction<string[]>
  setActiveSubStep: TSetStoreAction<number>
  setInitialStore: TSetInitStoreAction
  setEditingStep: TSetStoreAction<null | string>
}

export const getStore = (store: TStepsConfigStore) => ({
  hiddenSteps: store.hiddenSteps,
  activeSubStep: store.activeSubStep,
  activeStepIndex: store.activeStepIndex,
  finalizedSteps: store.finalizedSteps,
  editingStep: store.editingStep,
})

export const INITIAL_STORE = {
  hiddenSteps: DEFAULT_HIDDEN_STEPS,
  activeSubStep: 0,
  activeStepIndex: 0,
  finalizedSteps: [],
  editingStep: null,
}

export const useStepsProductNew = createStore<TStepsConfigStore>(set => ({
  ...INITIAL_STORE,
  setFinishedSteps: finalizedSteps => set({ finalizedSteps }),
  setActiveSubStep: activeSubStep => set({ activeSubStep }),
  setHiddenStep: values =>
    set(state => ({
      ...state,
      hiddenSteps: addManyItensArray(state.hiddenSteps, values),
    })),
  setVisibleStep: values =>
    set(state => ({
      ...state,
      hiddenSteps: removeManyItensArray(values, state.hiddenSteps),
    })),
  setActiveStepIndex: activeStepIndex => set({ activeStepIndex }),
  setInitialStore: () => set(INITIAL_STORE),
  setEditingStep: step => set({ editingStep: step }),
}))
